export default (theme) => ({
  drawerPaper: {
    width: 280,
  },
  container: {
    position: 'fixed',
    top: 0,
    width: 280,
    height: '100vh',
    backgroundColor: '#fff',
    boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
    [theme.breakpoints.down('sm')]: {
      right: '0 !important',
      width: '100%',
    },
  },
  containerInner: {
    flex: 1,
    overflow: 'auto',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px 0 16px',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
  },
  headerTitle: {
    fontWeight: 500,
  },
  headerDivider: {
    margin: '8px 0 0 0',
  },
  subHeaderTitle: {
    margin: '20px 20px 2px'
  },
  list: {
    padding: '2px 20px',
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: theme.spacing(1),
    borderRadius: 10,
    padding: 8,
    '&:hover': {
      backgroundColor: `${theme.palette?.worklogHistory?.lightBlue}`
    }
  },
  listItemText: {
    height: 30,
    alignContent: 'center',
  },
  listItemSelected: {
    backgroundColor: `${theme.palette?.worklogHistory?.lightBlue}CC`,
    '&:hover': {
      backgroundColor: `${theme.palette?.worklogHistory?.lightBlue}`,
    }
  },
  submissionButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'none',
    paddingLeft: 0,
    paddingRight: 0,
  },
  listItemDivider: {
    width: 'calc(100% - 16px)',
    marginLeft: 8,
  }
})